import Dexie from 'dexie';

const db = new Dexie('LocalAppData');
db.version(1).stores({
  students: 'id, name, class, syncStatus',
  staff: 'id, name, email, position, password, syncStatus',
  attendance: 'id, studentId, date, status, syncStatus',
  fees: 'id, studentId, amount, date, syncStatus',
  // Add other entities as needed
});

// Add sync status tracking
db.students.hook('creating', (primKey, obj) => {
  obj.syncStatus = obj.syncStatus || 'synced';
  obj.lastUpdated = obj.lastUpdated || new Date();
});

// Similar hooks for other tables

export default db;